module.exports = __webpack_public_path__ + "f1cc59a03aa272963696bb74a5804707.svg";